<template>
  <div class="cpn-datepicker"
       :class="[
         formatInput.replace(':', ''), type,
         className,
         {'shortMinute': shortMinute}]">
    <i v-if="isShowIcon" class="fa fa-calendar calendar-padding"/>
    <masked-input rel="dateMask"
                  type="text"
                  v-model="dateMask"
                  :name="name"
                  :mask="mask"
                  :showMask="showMask"
                  :keepCharPositions="false"
                  :autocomplete="'off'"
                  @click="focusMask"
                  :class="[
                    errors.maskInputClass || errorClass,
                    {'no-border': border, 'datemask-padding': isShowIcon }]"
                  :disabled="disabled"
                  :placeholder="placeholder"
    />
    <i v-if="isCanClearDate && '' !== dateMask" class="fa fa-times clear-padding" @click="clearDate"/>
    <div v-if="hasPicker"
         rel="datePickerDiv"
         class="picker"
    >
      <date-picker ref="datePicker"
                   class=""
                   v-model="datePicker"
                   :language="lang"
                   :lang="lang"
                   :format="formatInput"
                   :type="type"
                   :placeholder="placeholder"
                   :not-before="minDate"
                   :not-after="maxDate"
                  
      />
    </div>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import DatePicker from 'vue2-datepicker'

import moment from 'moment'

export default {
  name: "DatePickerInput",
  components: {
    MaskedInput,
    DatePicker
  },
  props: {
    className: {
      type: String,
      required: false,
    },
    errorClass: {
      type: String,
      required: false,
    },
    formatInput: {
      type: String,
      required: false,
      default: "DD-MM-YYYY",
    },
    formatOutput: {
      type: String,
      required: false,
      default: "YYYY-MM-DD HH:mm:ss",
    },
    minDate: {
      type: [String, Date],
      required: false,
      default: ""
    },
    maxDate: {
      type: [String, Date],
      required: false,
      default: ""
    },
    formatDisplay: {
      type: String,
      required: false,
      default: "",
    },
    value: {
      type: [String, Object],
      required: false,
      default: "",
      /*twoWay: true*/
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    name: {
      type: String,
      required: false,
      default: "",
    },
    showMask: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasPicker: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasTime: {
      type: Boolean,
      required: false,
      default: false,
    },
    lang: {
      type: String,
      required: false,
      default: 'en',
    },
    type: {
      type: String,
      required: false,
      default: 'date',//'date' | 'datetime' | 'year' | 'month' | 'time'
    },
    border: {
      type: Boolean,
      required: false,
      default: false
    },
    change: {
      type: Function,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false
    },
    shortMinute: {
      type: Boolean,
      required: false
    },
    isReturnWrongFormat: {
      type: Boolean,
      required: false,
      default: false
    },
    isShowIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    isCanClearDate: {
      type: Boolean,
      required: false,
      default: false
    },
    isClear: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  model: {
    prop: "value",
  },
  data() {
    return {
      mask: [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
      pickerVal: '',
      dateMask: '',
      selectedValue: this.value,
      //dateDisplay: this.convertDateFormat(this.value),
      //dateMask: this.convertDateFormat(this.value),
      //format: this.formatInput,
      dateFormat: this.formatInput,
      dateDisplay: this.formatDisplay ? this.formatDisplay : this.formatInput,
      datePicker: '',
      min: '',
      max: '',
      _className: this.className,
      errors: {
        maskInputClass: '',
        pickerInputClass: ''
      }
    }
  },
  beforeCreate() {

  },
  beforeMount() {
  },
  mounted() {
    if(this.selectedValue !== null && typeof this.selectedValue === 'object'){
      this.selectedValue = moment(this.selectedValue).format(this.formatInput);
    }

    if (this.formatInput == "DD-MM-YYYY" || this.formatInput == "MM-DD-YYYY") {
      this.mask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    } else if (this.formatInput == "YYYY-MM-DD") {
      this.mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
    }

    /*if(this.dateFormat.includes('HH:mm:ss')){
      this.mask.push(' ', /\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/);
    }else if(this.dateFormat == 'HH:mm'){
      this.mask = [/\d/, /\d/, ':', /\d/, /\d/];
    }*/
    if (this.type == 'datetime') {
      this.dateFormat += ' HH:mm:ss';
      this.mask.push(' ', /\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/);
    } else if (this.type == 'time') {
      if (this.dateFormat == 'HH:mm') {
        this.mask = [/\d/, /\d/, ':', /\d/, /\d/];
      } else {
        this.dateFormat = 'HH:mm:ss';
        this.mask = [/\d/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/];
      }
    }

    if (this.selectedValue) {
      var time = moment(this.selectedValue, this.dateFormat);
      this.dateMask = time.format(this.formatDisplay);
      this.datePicker = time;
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.selectedValue = newVal;
      var time = moment(this.selectedValue, this.dateFormat);
      this.dateMask = time.format(this.formatDisplay);
      this.datePicker = time;
    },
    className: function (newVal, oldVal) {
      this._className = newVal;
    },
    dateMask: function (newVal, oldVal) {
      let date = moment(newVal, this.dateDisplay);
      if (date && date.isValid() && newVal == date.format(this.dateDisplay)) {
        date = moment(newVal, this.formatOutput);
        this.errors.maskInputClass = '';

        let formatOutput = date.format(this.formatOutput);
        if (this.change) {
          this.change(formatOutput);
        }
      }else{
        if (this.isReturnWrongFormat && this.change) {
          this.change('');
        }
        this.errors.maskInputClass = 'error';
      }

      /*let valid = this.validateDate(newVal, this.dateDisplay);
      if (!valid) {
        this.errors.maskInputClass = 'error';
        if (this.change) {
          //this.$emit('update:value', null)
          //this.change(null, true);
        }
      } else {
        let date = moment(newVal, this.formatOutput);
        this.errors.maskInputClass = '';

        let formatOutput = date.format(this.formatOutput);
        //console.log(formatOutput)
        if (this.change) {
          //this.$emit('update:value', formatOutput)
          this.change(formatOutput);

        }
      }*/
    },
    datePicker: function (newVal, oldVal) {
      if (newVal) {
        let date = moment(newVal);
        //this.dateMask = this.convertDateFormat(date);
        this.dateMask = date.format(this.dateDisplay);
        this.errors.maskInputClass = '';
      }
    },
    isClear: function (newVal, oldVal) {
      if(newVal) {
        this.clearDate();
      }
    },
  },
  methods: {
    focusMask(e) {
      e.preventDefault();

      if (this.hasPicker) {
        let datePicker = this.$refs.datePicker;
        if (datePicker) {
          datePicker.showPopup()
        }
      }
    },
    convertDateFormat(val) {
      return this.$moment(val, this.dateFormat).format(this.dateFormat);
    },
    pickerChanged(val) {

    },
    validateDate(str, dateFormat) {
      if (str) {
        let date = moment(str, dateFormat);
        if (date && date.isValid() && str == date.format(dateFormat)) {
          return true;
        }
      }

      return false;
    },
    clearDate() {
      this.dateMask = '';
      this.datePicker = '';
    }
  }
}
</script>

<style scoped>
  .cpn-datepicker {

  }

  .cpn-datepicker input.error {
    border: 1px solid red;
  }

  .cpn-datepicker .no-border {
    border: none !important;
  }

  .cpn-datepicker input[type=text] {
    width: 100%;
    height: 100%;
    padding: 10px 10px;
  }

  .cpn-datepicker .mx-calendar {
    display: flex;
    flex-direction: column;
  }

  .datemask-padding {
    padding: 0px 30px !important;
  }

  .calendar-padding {
    position: absolute;
    top: 30%;
    margin-left: 10px;
  }

  .clear-padding {
    position: absolute;
    top: 30%;
    margin-left: -20px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/DatePickerInput.vue